export default {
	header: 'Lista grup',
	buttons: {
		addGroup: 'Stwórz nową grupę'
	},
	dialogs: {
		createGroup: {
			header: 'Stwórz nową grupę',
			avatar: 'Avatar',
			name: 'Nazwa grupy',
			description: 'Opis',
			type: 'Typ',
			permissions: 'Uprawnienia',
			create: 'Stwórz grupę',
			form: {
				name: 'Wpisz nazwę swojej grupy',
				addAvatar: 'Wgraj avatar',
				changeAvatar: 'Zmień avatar grupy',
				removeAvatar: 'Usuń avatar',
				addAvatarDesc: 'Waga nie powinna przekraczać 5MB. Dozwolone formaty to jpg, png, gif.',
				addAvatarInfo: 'Możesz to zrobić później podczas edytowania grupy',
				description: 'Napisz, o czym jest twoja grupa',
				public: 'Publiczna',
				publicDescription: 'Każdy użytkownik będzie mógł dołączyć bez potwierdzenia',
				private: 'Prywatna',
				privateDescription: 'Aby dołączyć, użytkownik będzie musiał wysłać prośbę do administratora grupy lub poprzez otrzymanie zaproszenia od członka grupy',
				characters: 'znaków',
				isHide: 'Ukryta (nie będzie można wyszukać grupy ani poprosić o dołączenie)',
				isJoinAllowed: 'Zezwól użytkownikom na wysyłanie próśb o dołączenie',
				isInvitationAllowed: 'Zezwól członkom grupy na zapraszanie użytkowników'
			}
		}
	}
}
